import { createRef, Component } from "react";
import PropTypes from "prop-types";
import styles from "./parallax.module.less";
import { extract, EventAggregator } from "@parksandresorts/core";

export default class Parallax extends Component {
  static propTypes = {
    parallaxOffset: PropTypes.number,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.ref_parallax = createRef();
    this.parallaxOffset = extract(props, "parallaxOffset");

    this.state = {
      style: {
        transform: `translate3d(0px, 0px, 0px)`,
      },
    };
  }

  componentDidMount() {
    this.onScrollSubcription = EventAggregator.subscribe("onScroll", this.onScroll);
  }

  componentWillUnmount() {
    if (this.onScrollSubcription) {
      this.onScrollSubcription.remove();
    }
  }

  onScroll = (yPos) => {
    if (typeof this.parallaxOffset === "number") {
      yPos = yPos - this.parallaxOffset;
    }
    if (yPos <= 0) {
      yPos = 0;
    }

    this.setState({
      style: {
        transform: `translate3d(0px, ${Math.round(yPos / 3)}px, 0px)`,
      },
    });
  };
  render() {
    return (
      <div className={styles.wrapper}>
        <div style={this.state.style} ref={this.ref_parallax} className={styles.parallax}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
